<template>
  <div>
    <div v-if="showing"
      class="fixed pt-24 pb-10 inset-0 w-full h-screen flex items-center justify-center bg-semi-75 z-20">
      <div class="mx-2 w-3/5  max-h-full bg-white shadow-lg rounded-lg px-5 overflow-auto">
        <div class="flex flex-col sticky top-0 bg-white pt-5 z-50">
          <div class="flex">
            <div class="w-4/5 text-left px-3 pb-3 text-purple-700 text-xl font-bold">
              Cómo copiar su ubicación desde google maps
            </div>
            <div class="w-1/5 text-right">
              <button aria-label="close" class="text-xl text-gray-500" @click.prevent="close">
                ×
              </button>
            </div>
          </div>
        </div>
        <div class="flex flex-wrap">
          <div class="flex flex-col w-full">

            <div>
              <div class="flex flex-wrap -mx-3 pb-3">

                <div class="w-full text-left  break-all px-3 mb-6 md:mb-0">
                  <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left">Hay dos
                    formas en las que puede copiar la ubicación desde Google Maps, descritas a continuación.</label>
                  <div class="relative">
                    <ul class="space-y-4 text-black list-disc break-all list-inside dark:text-gray-400">
                      <li>
                        <b>Primera Forma:</b>
                        <ol class="pl-5 mt-2 space-y-1 list-decimal break-all list-inside">
                          <li>Vaya a la página de Google maps y busque su ubicación.</li>
                          <li>Haga click derecho en el punto de su ubicación en el mapa, se le mostrará un menú.</li>
                          <li>Haga clic en las coordenadas que se muestran, esto copiará las coordenadas en el
                            portapapeles.</li>
                          <li>Pegue en contenido en el espacio destinado.</li>
                        </ol>
                        <img src="@/assets/helpMaps1.png" class="bg-red-200 w-full h-auto my-1" />
                      </li>
                      <li>
                        <b>Segunda Forma:</b>
                        <ul class="pl-5 mt-2 space-y-1 list-decimal break-all list-inside">
                          <li> Vaya a la página de Google maps y busque su ubicación.</li>
                          <li>Seleccione un punto en el mapa, se mostrará como un marcador rojo.</li>
                          <li>Seleccione todo el texto mostrado en la barra de direcciones del navegador y haga click
                            derecho, se mostrará un menú.</li>
                          <li>Haga click en copiar, esto copiará la dirección URL en el portapales.</li>
                          <li>Pegue la dirección en el espacio destinado, el sistema analizará el contenido de la
                            dirección
                            y obtendrá las coordenadas por usted.</li>
                        </ul>
                      </li>
                      <img src="@/assets/helpMaps2.png" class="bg-red-200 w-full h-auto my-1" />

                      <li>
                        <b>Ejemplos de valores válidos:</b>
                        <ul class="pl-5 mt-2 space-y-1 list-decimal break-all  list-inside">
                          <li>25.666201379998725,-100.3108276418661</li>
                          <li>
                            https://www.google.com.mx/maps/place/FORO+LUCILA+SABELLA/@25.6660162,-100.3105813,18.5z/data=!4m6!3m5!1s0x8662be2e786e4efb:0x167e4ab6d648fc5!8m2!3d25.6659542!4d-100.3105437!16s%2Fg%2F1z3tb5qrz?entry=ttu
                          </li>
                          <li>https://www.google.com.mx/maps/@25.6664736,-100.3113158,18.37z?entry=ttu</li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {

      
    };
  },
  props: {
    showing: {
      required: true,
      type: Boolean,
    },
    
  },
  watch: {
    showing(value) {
      if (value) {
        return document.querySelector("body").classList.add("overflow-hidden");
      }

      document.querySelector("body").classList.remove("overflow-hidden");
    },
  },
  mounted() {
  },
  components: {
  },
  methods: {

    close() {
      this.$emit("close");
    }
    
  },
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}

</style>
